// src/AdminLayout.jsx

import React from "react";
import { AppShell, Title } from "@mantine/core";
import { Routes, Route, Navigate } from "react-router-dom";

// Impor Navbar dan Header baru kita
import { NavbarMinimal } from "../components/NavbarMinimal";
import { HeaderMegaMenu } from "../components/HeaderMegaMenu";
import { FooterSimple } from "../components/FooterSimple";

// Impor Halaman-Halaman Anda
import AdminDashboardPage from "../pages/admin/AdminDashboardPage"
import UsersPage from "../pages/admin/UsersPage";
import WilayahPage from "../pages/admin/WilayahPage";
import AdminMenuPage from "../pages/admin/AdminMenuPage";
import AdminDistribusiPage from "../pages/admin/AdminDistribusiPage";
import AdminKonfirmasiPenerimaanPage from "../pages/admin/AdminKonfirmasiPenerimaanPage"; 
import AdminLaporanNutrisiPage from "../pages/admin/AdminLaporanNutrisiPage";           
import AdminLaporanMonitoringPage from "../pages/admin/AdminLaporanMonitoringPage";


export default function AdminLayout() {
  
  return (
    <AppShell
      padding="md"
      
      // --- 1. TAMBAHKAN PROP INI KEMBALI ---
      header={{ height: 60 }} 
      
      navbar={{ width: 80, breakpoint: 'sm' }}

      footer={{ height: 50 }} // Atur tinggi footer
    >
      
      {/* --- 2. BUNGKUS HEADER ANDA DENGAN <AppShell.Header> --- */}
      <AppShell.Header>
        <HeaderMegaMenu />
      </AppShell.Header>
      
      <AppShell.Navbar p={0}>
        <NavbarMinimal />
      </AppShell.Navbar>

      <AppShell.Footer p={0}>
        <FooterSimple />
      </AppShell.Footer>

      <AppShell.Main>
        {/* Konten Halaman Anda (Routes) tidak berubah */}
        <Routes>
          <Route path="/dashboard" element={<AdminDashboardPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/wilayah" element={<WilayahPage />} />
          <Route path="/menu" element={<AdminMenuPage />} />
          <Route path="/distribusi" element={<AdminDistribusiPage />} />
          <Route path="/konfirmasi-penerimaan" element={<AdminKonfirmasiPenerimaanPage />} />
          <Route path="/laporan-nutrisi" element={<AdminLaporanNutrisiPage />} />
          <Route path="/laporan-monitoring" element={<AdminLaporanMonitoringPage />} />
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </AppShell.Main>
    </AppShell>
  );
}